var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "max-width": "290"
    },
    model: {
      value: _vm.isOpen,
      callback: function callback($$v) {
        _vm.isOpen = $$v;
      },
      expression: "isOpen"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.opts.headline))]), _c('v-card-text', [_vm._v("\n      " + _vm._s(_vm.opts.text) + "\n    ")]), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": _vm.opts.agreeColor,
      "flat": "flat"
    },
    on: {
      "click": function click($event) {
        return _vm.agreeClicked();
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.opts.agree) + "\n      ")]), _c('v-btn', {
    attrs: {
      "color": _vm.opts.disagreeColor,
      "flat": "flat"
    },
    on: {
      "click": function click($event) {
        return _vm.disagreeClicked();
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.opts.disagree) + "\n      ")])], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }